import type { ReactElement } from 'react';

import { weekAndMonthDay } from 'utils/dateTimes';
import OrderHistoryMenu from 'models/OrderHistoryMenu';

import { Component as CurrentMenuIcon } from 'icons/icon-menu--current.svg';
import { Component as DownloadIcon } from 'icons/icon-ui--download.svg';
import PlanName from './PlanName';
import TrackingNumbers from './TrackingNumbers';

type Props = {
  item: OrderHistoryMenu;
};

function Header({ item }: Props): ReactElement {
  const {
    delivery_on: deliveryOn,
    donated,
    fulfillment_status: fulfillmentStatus,
    id,
    shipments,
  } = item;

  return (
    <>
      <div className="c-order__header">
        <div className="c-order__icon">
          <CurrentMenuIcon />
        </div>

        <div className="c-order__title c-order__title--order-history">
          <div className="d-flex">
            <div className="flex-grow-1 mr-3">
              <span className="c-heading c-heading--brand-8 d-block d-sm-inline">
                Delivery Week of:
                &nbsp;
              </span>
              {weekAndMonthDay(deliveryOn)}
              <div className="d-none d-sm-block">
                <PlanName item={item} />
              </div>
            </div>
            <div className="ml-auto">
              {!donated && shipments.length && (
                <TrackingNumbers shipments={shipments} />
              )}

              {fulfillmentStatus === 'confirmed' && (
                <a href={`/orders/${id}/receipt`} target="_blank" rel="noreferrer">
                  <DownloadIcon height={12} className="mr-1 c-svg-fill-primary-color" />
                  Download receipt
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="c-order__plan d-flex d-sm-none">
        <PlanName item={item} />
      </div>
    </>
  );
}

export default Header;
